import script from "./ModalFotos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFotos.vue?vue&type=script&setup=true&lang=js"

import "./ModalFotos.vue?vue&type=style&index=0&id=667d43e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667d43e3"]])

export default __exports__